import axiosPrivate from "./axiosPrivate";

// ─── RESUMEN UNIFICADO ────────────────────────────────────────────────────────
// Calcula en tiempo real desde MECHAsistencias. area: '' | '1' | '2' | '4'
const getResumen = (mes, area = '', status = '1') =>
    axiosPrivate.get("descuentos-planilla/resumen", { params: { mes, area: area || undefined, status } }).then(r => r.data);

// ─── OTROS (MECHDescuentosOtrosPlanilla) ─────────────────────────────────────
const getOtrosPorUsuario = (mes, usuario_id) =>
    axiosPrivate.get("descuento-otros/por-usuario", { params: { mes, usuario_id } }).then(r => r.data);

const storeOtros = (data) =>
    axiosPrivate.post("descuento-otros", {
        usuario_id:      data.usuario_id,
        fecha_periodo:   data.mes || data.fecha_periodo,
        descripcion:     data.motivo || data.descripcion,
        monto_descuento: data.monto_descuento,
    }).then(r => r.data);

const deleteOtros = (id) =>
    axiosPrivate.delete(`descuento-otros/${id}`).then(r => r.data);

export default {
    getResumen,
    getOtrosPorUsuario,
    storeOtros,
    deleteOtros,
};
